var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnionVector({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 59,
    viewBox: "0 0 70 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1539 9C67.1539 5.13401 64.0199 2 60.1539 2L9.84615 2C5.98016 2 2.84615 5.13401 2.84615 9L2.84615 11.4398L67.1539 11.4398L67.1539 9ZM2.84614 35.3946L2.84615 13.4398L48.1887 13.4398L48.1887 35.3946L2.84614 35.3946ZM2.84614 37.3946L2.84614 49.299C2.84614 53.165 5.98015 56.299 9.84615 56.299L24.9612 56.299L24.9612 37.3946L2.84614 37.3946ZM26.9612 37.3946L26.9612 56.299L48.1887 56.299L48.1887 37.3946L26.9612 37.3946ZM50.1887 56.299L50.1887 13.4398L67.1539 13.4398L67.1539 38.5327L67.1539 49.299C67.1539 53.165 64.0199 56.299 60.1539 56.299L50.1887 56.299ZM60.1539 -3.93403e-07C65.1244 -1.76133e-07 69.1539 4.02944 69.1539 9L69.1539 38.5327L69.1539 49.299C69.1539 54.2696 65.1244 58.299 60.1539 58.299L49.3875 58.299L9.84615 58.299C4.87558 58.299 0.846143 54.2696 0.846143 49.299L0.846145 9C0.846145 4.02944 4.87558 -2.80969e-06 9.84615 -2.59242e-06L60.1539 -3.93403e-07Z",
    fill: "#626262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnionVector);
export default __webpack_public_path__ + "static/media/union-vector.d49bb0a5bd902e92588427e93559607f.svg";
export { ForwardRef as ReactComponent };